var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-11/12 px-6 py-6 md:px-10 md:py-10 bg-white rounded-2xl shadow-lg"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }